import { AbortedError } from 'src/common/api/extended-emerald-error';
import { IReturnPolicy } from 'src/common/api/return-policy/return-policy-utils';
import { popEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { store } from 'src/common/redux/configure-store';
import { POSModeActions } from 'src/common/redux/reducers/pos-mode-reducer';
import {
  ForcedExchangeOverride,
  ForceExchangeModalProps,
  showForcedExchangeAmountModal,
} from '../force-exchange-modal';
import { forceExchangeOverride } from './service/force-exchange-override';
import { ForcedExchangeLines } from '../components/forced-exchange-list';

export const handleForcedExchange = async (policy: IReturnPolicy): Promise<void> => {
  await new Promise<void>((resolve, reject) => {
    const onCancel = (): void => {
      popEmeraldModal();
      reject(new AbortedError());
    };

    const onSaleMode = (): void => {
      popEmeraldModal();
      store.dispatch(POSModeActions.setReturnState(undefined));
      reject(new AbortedError());
    };

    const onOverride = (feData: ForcedExchangeOverride): void => {
      popEmeraldModal();
      forceExchangeOverride(feData)
        .then(resolve)
        .catch(reject);
    };

    const forcedExchangeActions: ForceExchangeModalProps = {
      policy,
      onCancel,
      onSaleMode,
      onOverride,
    };
    showForcedExchangeAmountModal(forcedExchangeActions);
  });
};

export const getSelectedSequenceNumbers = (
  forcedExchangeLines: ForcedExchangeLines[],
  selectedLines: number[],
): (string | null)[] => {
  const sLines = forcedExchangeLines.map((fel, index) => {
    if (selectedLines.includes(index)) {
      return fel.lineSequence;
    } else {
      return null;
    }
  });
  return sLines.filter(n => n);
};

export const bundleOnOverride = (
  onOverride: (feData: ForcedExchangeOverride) => void,
  forcedExchangeLines: ForcedExchangeLines[],
  selectedLines: number[],
  policy: IReturnPolicy,
  thresholdOverride: boolean,
): void => {
  onOverride({
    sequenceNumbers: getSelectedSequenceNumbers(forcedExchangeLines, selectedLines),
    thresholdOverride: thresholdOverride || false,
    returnPolicy: policy,
  });
};

export const isOverrideBtnDisabled = (
  isMangerBtnDisabled: boolean,
  selectedLines: number[],
  thresholdSelected: boolean,
): boolean => {
  let disabled = false;
  if (isMangerBtnDisabled) {
    disabled = true;
  }
  if (selectedLines.length === 0 && !thresholdSelected) {
    disabled = true;
  }
  return disabled;
};

type stateType = (value: React.SetStateAction<boolean>) => void;

export const handleSelectThreshold = (
  thresholdSelected: boolean,
  setthresholdSelected: stateType,
  setSelectAll: stateType,
): void => {
  if (thresholdSelected) {
    setthresholdSelected(false);
    setSelectAll(false);
  } else {
    setthresholdSelected(true);
    setSelectAll(true);
  }
};

export const getForcedExchangeTotal = (forcedExchangeTotal: string): string => {
  /**
   * Note / ToDo:
   * Due to a bug in legacy, additional research has to be done
   * to figure out how to the
   * totalExchangeAmount = (total line item amount) + (taxes) - (items added to the EJ)
   * Speak to Monica A. and/or Alex F. for additional details
   */
  // const sumOfAllItemAmounts: number = forcedExchangeLines.reduce(
  //   (accum, item) => accum + parseFloat(item.extendedAmount.amount),
  //   0,
  // );
  // const totalTaxes = sumOfAllItemAmounts - parseFloat(forcedExchangeTotal);
  // return (sumOfAllItemAmounts + totalTaxes).toFixed(2);
  return forcedExchangeTotal;
};
